import React, { useEffect, useState } from "react";
import { api } from "../api";

const renderGroup = (imgs, groupIdx) => {
  const [a, b, c, d, e, f, g] = imgs;
  const imgClass =
    "w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700";
  return (
    <div
      key={groupIdx}
      className="grid grid-cols-5 gap-2 md:gap-3 shrink-0 w-[1100px] md:w-[1400px] lg:w-[calc(100vw*1.15)] lg:min-w-[1400px]"
    >
      <div className="rounded-lg md:rounded-xl overflow-hidden bg-neutral-200 aspect-[3/5]">
        <img src={a} alt="Koptur Grup projesi" className={imgClass} loading="lazy" />
      </div>
      <div className="rounded-lg md:rounded-xl overflow-hidden bg-neutral-200 aspect-[3/5]">
        <img src={b} alt="Koptur Grup projesi" className={imgClass} loading="lazy" />
      </div>
      <div className="flex flex-col gap-2 md:gap-3">
        <div className="rounded-lg md:rounded-xl overflow-hidden bg-neutral-200 aspect-[4/3] flex-[1.2]">
          <img src={c} alt="Koptur Grup projesi" className={imgClass} loading="lazy" />
        </div>
        <div className="grid grid-cols-2 gap-2 md:gap-3 flex-1">
          <div className="rounded-lg md:rounded-xl overflow-hidden bg-neutral-200">
            <img src={d} alt="Koptur Grup projesi" className={imgClass} loading="lazy" />
          </div>
          <div className="rounded-lg md:rounded-xl overflow-hidden bg-neutral-200">
            <img src={e} alt="Koptur Grup projesi" className={imgClass} loading="lazy" />
          </div>
        </div>
      </div>
      <div className="rounded-lg md:rounded-xl overflow-hidden bg-neutral-200 aspect-[3/5]">
        <img src={f} alt="Koptur Grup projesi" className={imgClass} loading="lazy" />
      </div>
      <div className="rounded-lg md:rounded-xl overflow-hidden bg-neutral-200 aspect-[3/5]">
        <img src={g} alt="Koptur Grup projesi" className={imgClass} loading="lazy" />
      </div>
    </div>
  );
};

const chunk = (arr, size) => {
  const out = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
};

const MasonryHero = () => {
  const [urls, setUrls] = useState([]);

  useEffect(() => {
    api.heroImages().then((imgs) => setUrls(imgs.map((i) => i.url))).catch(() => {});
  }, []);

  if (urls.length < 7) {
    return (
      <section className="pt-[120px] pb-6 bg-white overflow-hidden">
        <div className="max-w-[1400px] mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-3">
          {urls.map((u, i) => (
            <div key={i} className="rounded-xl overflow-hidden aspect-[3/4] bg-neutral-100">
              <img src={u} alt="" className="w-full h-full object-cover grayscale" />
            </div>
          ))}
        </div>
      </section>
    );
  }

  const pool = [...urls, ...urls].slice(0, Math.max(21, Math.floor(urls.length / 7) * 7));
  const shifted = [...urls.slice(4), ...urls.slice(0, 4), ...urls].slice(0, pool.length);
  const groups1 = chunk(pool, 7).filter((g) => g.length === 7);
  const groups2 = chunk(shifted, 7).filter((g) => g.length === 7);

  return (
    <section className="pt-[92px] md:pt-[120px] pb-6 bg-white overflow-hidden">
      <div className="masonry-track relative">
        <div className="flex gap-2 md:gap-3 animate-scroll-left">
          {[...groups1, ...groups1].map((g, i) => renderGroup(g, `r1-${i}`))}
        </div>
      </div>
      <div className="h-2 md:h-3" />
      <div className="masonry-track relative">
        <div className="flex gap-2 md:gap-3 animate-scroll-right">
          {[...groups2, ...groups2].map((g, i) => renderGroup(g, `r2-${i}`))}
        </div>
      </div>
    </section>
  );
};

export default MasonryHero;
